<template>
    <div v-if="true" class="product-favorite" :class="{ 'product-favorite--active': isFavorite }" @click.prevent="changeFavoriteStatus">
        <svg viewBox="-1 -2 27 25" xmlns="http://www.w3.org/2000/svg">
            <path
                stroke-width="1"
                style="stroke-linecap: round; stroke-linejoin: round"
                d="M 20.774 2.496 C 19.622 1.365 18.097 0.748 16.469 0.748 C 14.84 0.748 13.31 1.369 12.159 2.5 L 11.557 3.091 L 10.947 2.492 C 9.795 1.36 8.262 0.731 6.633 0.731 C 5.009 0.731 3.479 1.356 2.332 2.483 C 1.18 3.615 0.549 5.117 0.553 6.717 C 0.553 8.317 1.193 9.816 2.345 10.947 L 11.102 19.55 C 11.222 19.668 11.385 19.731 11.544 19.731 C 11.703 19.731 11.867 19.672 11.987 19.554 L 20.765 10.964 C 21.917 9.833 22.553 8.33 22.553 6.73 C 22.557 5.13 21.926 3.627 20.774 2.496 Z"
            />
        </svg>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { useBasketStore } from '~/stores/basket'
import { GtmEcommerceEventTypeEnum } from '~/models/DataLayer/GtmEcommerceEventTypeEnum'
import FullProduct from '~/models/Product/FullProduct'
import DataLayer from '~/extensions/DataLayer'
import GtmEcommerceEvent from '~/models/DataLayer/GtmEcommerceEvent'
import { useAuthStore } from '~/stores/auth'
import Product from '~/models/Product/Product'
import { transformProductToGtmProduct } from '~/utils/transformProductToGtmProduct'

export default {
    props: {
        product: {
            type: Object as PropType<FullProduct | Product>,
            required: true,
        },
    },

    data() {
        return {
            isFavorite: false,
        }
    },

    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()

            return basketStore.authUser
        },
    },

    mounted() {
        const basketStore = useBasketStore()
        this.isFavorite = (basketStore.favoriteProductIds || []).includes(this.product.id)
    },

    methods: {
        async changeFavoriteStatus(): Promise<void> {
            const authStore = useAuthStore()
            const accessToken = authStore.accessToken

            if (this.isFavorite) {
                this.isFavorite = false
                await this.$repository.removeFavorite(this.product.id, { accessToken }).then(async () => {
                    await this.reloadUserData()
                })
            } else {
                this.isFavorite = true
                const ecommerceEvent = {
                    type: GtmEcommerceEventTypeEnum.AddToFavorites,
                    products: [transformProductToGtmProduct(this.product)],
                } as GtmEcommerceEvent

                DataLayer.pushEcommerceEventToDataLayer(ecommerceEvent)

                await this.$repository.addFavorite(this.product.id, { accessToken }).then(async () => {
                    await this.reloadUserData()
                })
            }
        },

        async reloadUserData() {
            const basketStore = useBasketStore()
            await basketStore.fetchData()
        },
    },
}
</script>

<style lang="scss" scoped>
.product-favorite {
    position: absolute;
    top: 10px;
    width: 24px;
    left: 0.5em;
    z-index: 1;

    &:deep(svg) {
        fill: #fff;
        stroke: $color-dark;
        cursor: pointer;
        transition: all 0.2s;
        max-width: 24px;
    }

    &:hover:deep(svg) {
        fill: $color-cta-extra-light;
        stroke: $color-cta;
    }

    &--active {
        &:hover:deep(svg) {
            fill: $color-cta;
            stroke: $color-cta;
        }
    }

    &--active:deep(svg) {
        fill: $color-cta;
        stroke: $color-cta;
    }
}

@media (max-width: 768px) {
    .product-favorite.detailFavorite {
        right: 0;
        left: auto;
    }
}
</style>
